module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Heartfelt gratitude to John Tagholm, Richard White and Caroline Davis, the special people who read the draft of my novel and offered me wise and constructive critical comments.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Two publications, compiled by Hilary Heffernan "), _c('em', [_vm._v("The Annual Hop London to Kent")]), _vm._v(" (1996 Tempus) and "), _c('em', [_vm._v("Voices of Kent Hop Pickers")]), _vm._v(" (1999 Tempus) informed my understanding of hop picking with background information and pictorial history.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("My grateful thanks to Jane Feaver, Sam North and Andy Brown, my tutors on the Masters course in creative writing at Exeter University for giving me a much better understanding of literature and encouraging my literary aspirations.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Thanks to my wife Margaret, daughters Lucy and Oonagh and extended family for their loving encouragement and support.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Thanks to Austin Macauley, my publishers.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0